/* eslint-disable max-len */
import http from '@/services/api/http';

const DEFAULT_TIMELINE = '30d';

export default {
  getMarketChartData({
    marketId,
    timespan = DEFAULT_TIMELINE,
    maxContracts = 4,
    storyId = null,
    regionUUID = null,
    sectionType = null,
    chartStoryVersionId = null,
  }) {
    const isTimespanInHours = timespan.includes('h');
    let finalTimespan = timespan.replace('h', '').replace('d', '');
    if (finalTimespan === '0') {
      finalTimespan = '';
    }
    if (storyId) {
      return http.get(
        `api/Public/GetMarketChartData/${marketId}?timespan=${finalTimespan}&maxContracts=${maxContracts}&isTimespanInHours=${isTimespanInHours}&chartUUID=${regionUUID}&chartStoryId=${storyId}&sectionType=${sectionType || ''}&chartStoryVersionId=${chartStoryVersionId || ''}`,
      );
    }
    return http.get(
      `api/Public/GetMarketChartData/${marketId}?timespan=${finalTimespan}&maxContracts=${maxContracts}&isTimespanInHours=${isTimespanInHours}`,
    );
  },
  getContractChartData(contractId, timespan = DEFAULT_TIMELINE) {
    return http.get(`api/Public/GetContractChartData/${contractId}?timespan=${timespan}`);
  },
};
